import join from 'url-join';

import { asyncAction, http } from '../../util';

import { requestOrderDetails } from '../actions';

const api2 = join(import.meta.env.VITE_API2_URL, 'v1');

export const requestSubmittedReturnDetails = asyncAction({
  baseName: 'REQUEST_RETURN_DETAILS',
  action: action => id => dispatch => {
    dispatch(action.start());
    return http
      .get(join(api2, `/returns/${id}`))
      .then(({ data: response }) => {
        dispatch(requestOrderDetails(response.orderId));
        return dispatch(action.success(response));
      })
      .catch(error => dispatch(action.error({ error })));
  }
});
